@if (showContent) {
  <eca-header-base></eca-header-base>
}
@if (showContent) {
  <eca-pillar-box>
    <router-outlet></router-outlet>
  </eca-pillar-box>
}
@if (showContent) {
  <eca-footer fxHide.lt-md id="ecafooter"></eca-footer>
}
